import { Injectable } from "@angular/core";
import { Actions } from "@ngrx/effects";
import { LocalStorageService } from "src/service/local-storage.service";

@Injectable()
export class LocalStorageEffects {
  constructor(
    private _actions$: Actions,
    private _localStorageService: LocalStorageService
  ) {}
}
